import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CommunityDetailsComponent from '../../components/CommunityDetails';
import {
  getCommunityByIdRequest,
  updateCommunityRequest,
} from '../../actionCreators/communitiesActions';
import { addAlertToAlertsList } from '../../actionCreators/globalAlerts';

import { RESET_COMMUNITY_BY_ID_SUCCESS } from '../../constants/actionTypes';

const CommunityDetails = (props) => <CommunityDetailsComponent {...props} />;

const CommunityDetailsContainer = (props) => {
  const state = useSelector((state) => ({
    communities: state.communities.communitiesList,
    currentCommunity: state.communities.currentCommunity,
    currentUser: state.currentUser.userData,
  }));

  const dispatch = useDispatch();

  const actions = {
    addAlertToAlerts: payload => dispatch(addAlertToAlertsList(payload)),
    getCommunityByid: (payload) => dispatch(getCommunityByIdRequest(payload)),
    updateCommunity: (payload) => dispatch(updateCommunityRequest(payload)),
    resetCommunityByid: () =>
      dispatch({
        type: RESET_COMMUNITY_BY_ID_SUCCESS,
        payload: '',
      }),
  };

  return <CommunityDetails {...props} {...state} {...actions} />;
};

export default CommunityDetailsContainer;
